import { formatDateLocal } from "../../../karyawan/helpers/timeline";
export const columnsDataDevelopment = [
  {
    Header: "No",
    accessor: "__index", // virtual accessor
  },
  {
    Header: "Number Ticket",
    accessor: "number_ticket",
  },
  {
    Header: "Judul",
    accessor: "subject",
  },
  
  {
    Header: "Deskripsi",
    accessor: "description",
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: (value) => formatDateLocal(value),
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    Cell: (value) => formatDateLocal(value),
  },
];
